import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ fontColor }) => fontColor};
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 18px;
  padding: 4px 12px;
  width: fit-content;
`;
